import { StyleObject } from 'styletron-react';

export const actionStyles = (active: any) => {
    return {
        'svg': {
            flex: '0 0 auto',
            margin: 'auto',
            height: '100%',
            overflow: 'visible',
            fill: '#919eab',
        }
    } as StyleObject;
}
